import styled from 'styled-components'
import { Alert, Card, TextAreaFormGroup, Text } from '@amzn/storm-ui'

export const StyledCard = styled(Card)`
  width: 60%;
  padding-top: ${({ theme }) => theme.spacing.large};
  margin: auto;
`

export const TopAlertContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.large};
  display: flex;
  justify-content: center;
`
export const AlertContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.small};
`
export const StyledAlert = styled(Alert)`
  width: 59%;
`
export const BoldText = styled(Text)`
  font-weight: bold;
`

export const InviteDataEntryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`
export const FormRowContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
`
export const FormFieldNameContainer = styled.div`
  flex-basis: 13%;
  text-align: end;
`
export const FormFieldValueContainer = styled.div`
  flex-basis: 85%;
`
export const EmailFieldEntryContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  flex-direction: column;
`
export const TextAreaFormGroupStyled = styled(TextAreaFormGroup)`
  min-width: 90%;
`
export const RoleInfoContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.micro};
  flex-direction: column;
`
